import { Link } from "react-router";

import { GetAllCoachProductsQuery } from "@/graphql";
import { Specialty } from "@/types/products";

import { Description } from "./Description";
import { InactiveProducts } from "./InactiveProducts";
import { Product } from "./Product";

type CoachProduct =
  GetAllCoachProductsQuery["productsByCoachId"]["coachProducts"][number];

interface SpecialtiesProps {
  coachSlug: string;
  specialties: Specialty[];
  coachProducts: CoachProduct[];
  asCoach: boolean;
  showLinks: boolean;
  noBorder?: boolean;
  showSpecialtyInfo?: boolean;
  isAssignedCoach: boolean;
}

export function Specialties({
  coachSlug,
  specialties,
  coachProducts,
  asCoach = false,
  showLinks = true,
  noBorder = false,
  showSpecialtyInfo = true,
  isAssignedCoach = false,
}: SpecialtiesProps) {
  return (
    <>
      <div className="text-2xl font-semibold text-gray-900 min-w-[130px] my-4 font-serif">
        All Services
      </div>

      {specialties.map((specialty) => {
        // Filter out intro products
        const filteredProducts = asCoach
          ? specialty.products
          : specialty.products.filter((product) => !product.introProduct);

        // Skip specialty if no non-intro products
        if (filteredProducts.length === 0) {
          return null;
        }
        const specialtyRoute = `/@${coachSlug}/${specialty?.slug}`;

        return (
          <div
            key={specialty.specialtyId}
            className={`
              m-0
              ${!noBorder ? "shadow-sm bg-white border border-gray-200 rounded-lg" : ""}
              ${showSpecialtyInfo ? "px-3 sm:px-3 md:px-3 lg:px-4" : ""}
              pb-2
              ${showSpecialtyInfo ? "my-9" : ""}
            `}
          >
            {showSpecialtyInfo && (
              <div className="pt-3">
                {showLinks ? (
                  <Link to={specialtyRoute}>
                    <h4>{specialty.name}</h4>
                  </Link>
                ) : (
                  <h4>{specialty.name}</h4>
                )}
                <div className="opacity-80">
                  <Description text={specialty.description || ""} />
                </div>
              </div>
            )}

            {filteredProducts.map((product) => {
              const coachProduct = coachProducts.find(
                (coachProduct) => coachProduct.productId === product.id,
              );
              if (!coachProduct) {
                return null;
              }
              return (
                <Product
                  product={product}
                  coachProduct={coachProduct}
                  key={product.id}
                  asCoach={asCoach}
                  showLinks={showLinks}
                  coachSlug={coachSlug}
                  isAssignedCoach={isAssignedCoach}
                />
              );
            })}

            <InactiveProducts inactiveProducts={specialty.inactiveProducts} />
          </div>
        );
      })}
    </>
  );
}
